import Alpine from 'alpinejs'

const cart = {
  visible: false,
  amount: 0,
  setAmount(value) {
    this.amount = value
  },

  async updateCartDrawer() {
    try {
      const drawerContent = document.querySelector(
        '[x-ref="cart_drawer_content"]'
      )
      Alpine.store('isLoading').setIsLoading(true)
      const res = await fetch('/cart')
      const cartMarkup = await res.text()
      const parser = new DOMParser()
      const markup = parser.parseFromString(cartMarkup, 'text/html')
      const newCartSectionMarkup = markup.querySelector(
        '[x-ref="cart_drawer_content"]'
      )
      drawerContent.innerHTML = newCartSectionMarkup.innerHTML

      Alpine.store('isLoading').setIsLoading(false)
      this.showCartDrawer = true
    } catch (error) {
      console.error('Error updating cart drawer:', error)
    }
  },
  async updateQuantity(line, qty) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ quantity: qty, line: line }),
      })
      const data = await response.json()
      // console.log('The cart is updated', data)
      this.amount = data.item_count
      window.dispatchEvent(new Event('cart-products'))
      window.dispatchEvent(new Event('cart-updated'))
    } catch (error) {
      console.log('Error', error)
    }
  },
  toggle(value) {
    if (typeof value === 'undefined') {
      this.visible = !this.visible
    } else {
      this.visible = value
    }
  },

  async init(initialAmount) {
    this.amount = initialAmount
  },
}

export default cart
